var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResidentialCareHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "residential-care-home_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.796 39.297l27.207-26.444 27.2 26.444M23.397 12.672v16.37m8.14 39.29V53.906a2.71 2.71 0 012.71-2.709h12.096a2.71 2.71 0 012.709 2.71v14.427M63.027 45.5v23.063H17.182V45.501l23.114-22.178 22.73 22.178z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTIuNzk1OSAzOS4yOTczTDQwLjAwMjYgMTIuODUyNkw2Ny4yMDM2IDM5LjI5NzNNMjMuMzk2NCAxMi42NzJWMjkuMDQxMk0zMS41MzU5IDY4LjMzMjhWNTMuOTA1M0MzMS41MzU5IDUzLjE4NjggMzEuODIxMyA1Mi40OTc2IDMyLjMyOTQgNTEuOTg5NUMzMi44Mzc1IDUxLjQ4MTQgMzMuNTI2NyA1MS4xOTYgMzQuMjQ1MiA1MS4xOTZINDYuMzQxNUM0Ny4wNjAxIDUxLjE5NiA0Ny43NDkyIDUxLjQ4MTQgNDguMjU3MyA1MS45ODk1QzQ4Ljc2NTQgNTIuNDk3NiA0OS4wNTA5IDUzLjE4NjggNDkuMDUwOSA1My45MDUzVjY4LjMzMjhNNjMuMDI2NiA0NS41MDA2VjY4LjU2NDJIMTcuMTgxN1Y0NS41MDA2TDQwLjI5NjEgMjMuMzIzMkw2My4wMjY2IDQ1LjUwMDZaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";
export { SvgResidentialCareHome as ReactComponent };